export default {
  methods: {
    cleanInfSignup: function () {
      if (process.client) {
        window.localStorage.removeItem("authCreateUserBackup")
        window.localStorage.removeItem("createBaseInfluencerBackup")
        window.localStorage.removeItem("patchLinkInfluencerBackup")
        window.localStorage.removeItem("patchSubsAndGenreBackup")
      }
    },
    cleanBandSignup: function () {
      if (process.client) window.localStorage.removeItem("flowSignupBackUp")
    },
    cleanCacheLang: function () {
      this.$cookies.remove("switchLang")
    },
    cleanPaypalAuthBackup: function () {
      this.$cookies.remove("paypal_pending_payment")
    },
    cleanDraftProgress: function (draft_id = 0) {
      if (process.client) {
        const boolean_checks = [
          "past_sendtrack_step",
          "past_selection_step",
          "past_message_step",
          "past_recap_step",
        ].forEach((key) => {
          this.$cookies.remove(`${key}_${draft_id}`)
        })
      }
    },
    cleanCacheAll: function () {
      this.cleanBandSignup()
      this.cleanInfSignup()
      this.cleanCacheLang()
      this.cleanPaypalAuthBackup()
    },
  },
}
